export const formatPhoneNumber = (number: string | null): string => {
  if (!number) return "";
  const cleanNumber = number.replace(/\D/g, "");

  // Aplicar el formato deseado (XXX-XXX-XXXX)
  const format = /(\d{3})(\d{3})(\d{4})/;
  return cleanNumber.replace(format, "$1-$2-$3");
};
